import { Instance, types } from 'mobx-state-tree';
import { RouteTagDtoModelBase } from './RouteTagDtoModel.base';

/* The TypeScript type of an instance of RouteTagDtoModel */
export interface RouteTagDtoModelType extends Instance<typeof RouteTagDtoModel.Type> {}

/* A graphql query fragment builders for RouteTagDtoModel */
export { selectFromRouteTagDto, routeTagDtoModelPrimitives, RouteTagDtoModelSelector } from './RouteTagDtoModel.base';

/**
 * RouteTagDtoModel
 *
 * Override uuid from types.identifier to types.string to match OrderTagDto pattern.
 * Tags are inline embedded objects within each route's tags array. Using
 * types.identifier causes MST to throw "Cannot resolve unambiguously" when
 * multiple routes share the same tag (same uuid), because MST's identifier
 * cache finds duplicate candidates of the same type.
 */
export const RouteTagDtoModel = RouteTagDtoModelBase
  .props({
    uuid: types.string,
  })
  .actions(self => ({
    log() {
      console.log(JSON.stringify(self));
    },
  }));
